import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";

/**
 * Badges informativos da chamada / RT no cabeçalho do lead.
 *
 * Antigos botões "Iniciar/Terminar Chamada" e "RT Realizada" foram
 * removidos (Fev 2026) — a chamada deixou de ser rastreada por botão e
 * a RT passa a ser considerada realizada automaticamente quando o
 * Consultor confirma a estimativa da RT (endpoint
 * ``/qt/confirm-estimate``). Este componente agora apenas mostra:
 *   - contador "N× chamadas" quando existirem segmentos históricos
 *   - badge verde "RT feita" quando ``rt_completed_at`` está preenchido
 */
export function CallControls({ lead }) {
  const segments = Array.isArray(lead?.call_segments) ? lead.call_segments : [];
  const count = segments.length;
  return (
    <>
      {count > 0 && (
        <span
          data-testid="call-count"
          className="text-[10px] text-muted-foreground bg-muted border border-border rounded-full px-2 py-1"
          title={`${count} chamada(s) registada(s) neste lead`}
        >
          {count}× chamadas
        </span>
      )}
      {lead?.rt_completed_at && (
        <span
          data-testid="rt-done-badge"
          className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.15em] font-semibold text-[hsl(var(--success))] bg-[hsl(var(--success-bg))] border border-[hsl(var(--success))]/25 rounded-full px-2 py-1"
          title={`RT realizada em ${new Date(lead.rt_completed_at).toLocaleString("pt-PT")}${lead.rt_completed_by_name ? " · " + lead.rt_completed_by_name : ""}`}
        >
          <CheckCircle2 className="w-3 h-3" /> RT feita
        </span>
      )}
    </>
  );
}
